import { post, get } from '../../index.js'
import base from '../../base.js'
import qs from 'query-string'

export const login = (params) => post(`${base.login}?${qs.stringify(params)}`)
export const logout = () => post(base.logout)
export const getCode = (params) => get(base.getCode, params)
export const loginCode = (params) => post(`${base.loginCode}?${qs.stringify(params)}`)
